import { useEffect, useRef } from "react";
import Actionbar from "src/components/common/actionbar/Authactionbar";
import { Message } from "src/components/common/form/Message";
import { useMouseContent } from "src/utils/mouse/mouseContent";

import { useTQC2060_R01Store } from "./Store_TQC2060_R01";

import { AgGridReact } from "ag-grid-react";
import { Content_TQC2060_R01 } from "./Content_TQC2060_R01";
import { TQC2060_R01HeaderDto, TQC2060_R01DetailDto } from "./Dto_TQC2060_R01";
import { Info_TQC2060_R01 } from "./Info_TQC2060_R01";
import { SearchSection_TQC2060_R01 } from "./SearchSection_TQC2060_R01";
import { Table_TQC2060_R01 } from "./Table_TQC2060_R01";
import { DetailTable_TQC2060_R01 } from "./DetailTable_TQC2060_R01";
import { Images_TQC2060_R01 } from "./Images_TQC2060_R01";

export const Container_TQC2060_R01 = () => {
	
	const { 
		TQC2060_R01List, TQC2060_R01DetailList,
	} = useTQC2060_R01Store();

	// leftWidth가 변경될 때 localStorage에 저장

	const RESIZER = {
		code: 'TQC2060_R01',
		type: 'width',
		storageKey: 'TQC2060_R01-split-width',
		min: 5,
		max: 80,
		default: 25
	} as const;
	const gridRef = useRef<AgGridReact<TQC2060_R01HeaderDto>>(null);

	
	const containerRef = useRef<HTMLDivElement>(null);
	const infoRef = useRef<HTMLDivElement>(null);
	const imagesRef = useRef<HTMLDivElement>(null);
	const isResizing = useRef(false);

	

	const { 
		splitValue,
		handleMouseDown,
		handleMouseUp
	} = useMouseContent({
		resizer: RESIZER,
		isResizing,
		containerRef,
		infoRef
	});

	const detailGridRef = useRef<AgGridReact<TQC2060_R01DetailDto>>(null);
	
	// Info와 DetailTable+Images 간 리사이저 설정
	const INFO_RESIZER = {
		code: 'TQC2060_R01_INFO',
		type: 'height',
		storageKey: 'TQC2060_R01-info-split-height',
		min: 20,
		max: 80,
		default: 40
	} as const;
	
	const isResizingInfo = useRef(false);
	const { 
		splitValue: infoSplitValue,
		handleMouseDown: handleInfoMouseDown,
	} = useMouseContent({
		resizer: INFO_RESIZER,
		isResizing: isResizingInfo,
		containerRef: infoRef,
	});
	
	// Detail Table과 Images 간 리사이저 설정
	const DETAIL_RESIZER = {
		code: 'TQC2060_R01_DETAIL',
		type: 'width',
		storageKey: 'TQC2060_R01-detail-split-width',
		min: 30,
		max: 70,
		default: 50
	} as const;
	
	const isResizingDetail = useRef(false);
	const { 
		splitValue: detailSplitValue,
		handleMouseDown: handleDetailMouseDown,
	} = useMouseContent({
		resizer: DETAIL_RESIZER,
		isResizing: isResizingDetail,
		containerRef: infoRef,
		infoRef: imagesRef
	});

	const {
		handlePrintClick,
		handleExcelClick,
		fetchData,
		useEquipmentCdList,
		defaultTQC2060_R01HeaderRow,
		initContainerData,
		handleDeleteClick,
		handleCreateClick,
		handleSaveClick,
	} = Content_TQC2060_R01({
		gridRef,
		containerRef,
		
	});

	useEffect(() => { 
		if (TQC2060_R01List.length === 0 && TQC2060_R01DetailList.length === 0) { handleCreateClick(); }
	}, [TQC2060_R01List, TQC2060_R01DetailList, handleCreateClick]);

	return (
	<div className="content-container">
		{/* filter: {JSON.stringify(TQC2060_R01Filter)}<br/> */}
		{/* pastFilter: {JSON.stringify(TQC2060_R01PastFilter)}<br/> */}
		<Actionbar
			onFetchClick={fetchData}
			onCreateClick={handleCreateClick}
			onDeleteClick={handleDeleteClick}
			onSaveClick={handleSaveClick}
			onExcelClick={handleExcelClick}
			onPrintClick={handlePrintClick}
			onInitClick={initContainerData}
		/>
		<SearchSection_TQC2060_R01 />
		<div className="flex flex-1 p-[12px] gap-[4px] min-h-0" ref={containerRef}>
			<div className="h-full" style={{ width: `${splitValue}%` }}>
				<Table_TQC2060_R01 gridRef={gridRef} defaultTQC2060_R01HeaderRow={defaultTQC2060_R01HeaderRow()} />
			</div>
			{/* 리사이저 */}
			<div
				className="w-[6px] bg-gray-100 cursor-col-resize hover:bg-gray-300"
				onMouseDown={(e: React.MouseEvent<HTMLDivElement>) => handleMouseDown('LR', e.nativeEvent)}
				// 드래그 시작 방지
				onDragStart={(e: React.DragEvent<HTMLDivElement>) => e.preventDefault()}
			/>
			<div className="h-full" style={{ width: `${100 - splitValue}%` }} ref={infoRef}>
				{/* 오른쪽: 상단은 시험 정보, 하단은 가로로 디테일테이블 / 이미지 */}
				<div className="h-full flex flex-col gap-[4px]">
					{/* 시험 정보 */}
					<div
						className="w-full"
						style={{ height: `${infoSplitValue}%` }}
					>
						<Info_TQC2060_R01
							useEquipmentCdList={useEquipmentCdList}
							defaultTQC2060_R01HeaderRow={defaultTQC2060_R01HeaderRow()}
						/>
					</div>
						{/* Info와 DetailTable+Images 간 수평 리사이저 */}
					<div
						className="h-[6px] bg-gray-100 cursor-row-resize hover:bg-gray-300"
						onMouseDown={(e: React.MouseEvent<HTMLDivElement>) => handleInfoMouseDown("UD", e.nativeEvent)}
						onDragStart={(e: React.DragEvent<HTMLDivElement>) => e.preventDefault()}
					/>
					{/* 디테일(왼쪽) / 이미지(오른쪽) - 가로 배치 */}
					<div
							className="w-full min-h-0 flex gap-[4px] "
							style={{ height: `${100 - infoSplitValue}%` }}
						>
							{/* 디테일 테이블 */}
							<div
								className="min-w-0" 
								ref={imagesRef}
								style={{ width: `${detailSplitValue}%` }}
							>
								<DetailTable_TQC2060_R01 detailGridRef={detailGridRef} />
							</div>
							{/* 리사이저 */}
							<div
								className="w-[6px] bg-gray-100 cursor-col-resize hover:bg-gray-300"
								onMouseDown={(e: React.MouseEvent<HTMLDivElement>) => handleDetailMouseDown('LR', e.nativeEvent)}
								onDragStart={(e: React.DragEvent<HTMLDivElement>) => e.preventDefault()}
							/>
							{/* 이미지 */}
							<div
								className="min-w-0"
								style={{ width: `${100 - detailSplitValue}%` }}
							>
								<Images_TQC2060_R01 />
							</div>
					</div>
				</div>
			</div>
		</div>
		<Message />
		
	</div>
	)
}
